import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Typekit from "react-typekit";

// Always-present Routes/Components
import Navbar from "./components/Navbar";
import Routes from "./Routes";
import Footer from "./components/Footer";

import "./App.css";

export default class App extends Component {
  state = { fixed: false };

  showFixedNav = () => this.setState({ fixed: true });

  hideFixedNav = () => this.setState({ fixed: false });

  render() {
    const { fixed } = this.state;

    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div id="router-child-container">
          <Typekit kitId="ucw4grp" />

          <Route path="/" render={props => <Navbar fixed={fixed} />} />

          <Routes
            onBottomPassed={this.showFixedNav}
            onBottomPassedReverse={this.hideFixedNav}
          />

          <Route path="/" component={Footer} />
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js